import { Topic } from '@/types'
import { formattedNumber } from '@/utils/helper'
import { FavoriteBorder, RemoveRedEyeOutlined } from '@mui/icons-material'
import { Box } from '@mui/material'

interface Props {
  topic: Topic
}
const TopicStatMini = (props: Props) => {
  const { topic } = props

  const viewsCount = Number(topic.visitorVisits || 0) + Number(topic.ownerVisits || 0)
  const likesCount = Number(topic.totalLikes) || 0

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      {likesCount > 0 && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            color: '#94a3b8',
            fontSize: '12px',
            fontWeight: 600,
          }}
        >
          <FavoriteBorder sx={{ fontSize: 14 }} />
          {formattedNumber(likesCount)}
        </Box>
      )}

      {viewsCount > 0 && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            color: '#94a3b8',
            fontSize: '12px',
            fontWeight: 600,
          }}
        >
          <RemoveRedEyeOutlined sx={{ fontSize: 14 }} />
          {formattedNumber(viewsCount)}
        </Box>
      )}
    </Box>
  )
}

export default TopicStatMini
